import { createFeatureSelector, createSelector } from "@ngrx/store";
import { BankingState } from "@pages/mobucks/state/banking.state";

export const selectAllBankingState = createFeatureSelector<BankingState>('banking');
export const selectAvailableCardThemes = createSelector(selectAllBankingState,(state: BankingState) => state.cards?.availableThemes);